<script setup lang="ts">
  import { MpActionsModal } from '@borg/ui';

  const props = defineProps<{
    isOpen: boolean;
    inProgress: boolean;
  }>();

  const emits = defineEmits<{
    'update:isOpen': [open: boolean];
    confirm: [];
    cancel: [];
  }>();

  function onConfirm() {
    if (!props.inProgress) {
      emits('confirm');
    }
  }

  function onCancel() {
    if (!props.inProgress) {
      emits('cancel');
    }
  }

  function onUpdateIsOpen(value: boolean) {
    if (!props.inProgress) {
      emits('update:isOpen', value);
    }
  }
</script>

<template>
  <MpActionsModal
    :is-open="isOpen"
    :confirm-button-is-loading="inProgress"
    :confirm-button-disabled="inProgress"
    :cancel-button-disabled="inProgress"
    @update:is-open="onUpdateIsOpen"
    @confirm="onConfirm"
    @cancel="onCancel"
    @overlay-click="onCancel"
  >
    <slot />
  </MpActionsModal>
</template>
